import { polyfill } from 'seamless-scroll-polyfill';

if (typeof window !== 'undefined') {
  polyfill();
}

export default function scrollToRef(element: HTMLElement) {
  return () => {
    window.scrollTo({
      top: element.offsetTop,
    });
  };
}
